import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../services/i18nService';

import OptionButton from './OptionButton';

const TTSButton = ({ clickHandler, a11yAttributes }) => {
    return (<OptionButton
        iconClass="fa fa-volume-up fa-fw"
        clickHandler={clickHandler}
        title={t('options.tts')}
        a11yAttributes={a11yAttributes}
    />);
};

TTSButton.propTypes = {
    clickHandler: PropTypes.func.isRequired,
    a11yAttributes: PropTypes.object,
};

export default TTSButton;
